var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout medical-analyse-form" },
    [
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _vm.loading
        ? _c("c-loader", {
            attrs: { label: "", active: _vm.loading, height: "500" },
          })
        : _c("div", [
            _c("div", { staticClass: "layout-header" }, [
              _c("div", { staticClass: "layout-title" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.id ? "Редактирование анализа" : "Новый анализ") +
                    " "
                ),
              ]),
              _c("div", { staticClass: "layout-header-actions" }, [
                _vm.id
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "layout-header-action medical-analyse-form-action",
                      },
                      [
                        _c("c-button-2", {
                          attrs: {
                            size: "small",
                            label: "Удалить",
                            icon: {
                              icon: "trash",
                              color: "secondary",
                            },
                          },
                          on: { click: _vm.deleteAnalyse },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "layout-header-action medical-analyse-form-action",
                  },
                  [
                    _c("c-button-2", {
                      attrs: {
                        size: "small",
                        label: "К списку анализов",
                        icon: {
                          icon: "back",
                          color: "blue",
                        },
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "medical-analyses-list",
                          })
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", [
              _c(
                "div",
                { staticClass: "document-form__name" },
                [
                  _c("c-input-2", {
                    style: {
                      "margin-bottom":
                        _vm.submitted && _vm.nameError ? "40px" : "",
                    },
                    attrs: {
                      "floating-label": "Название анализа",
                      "required-mark": true,
                      required: _vm.submitted && _vm.nameError,
                      "required-message": _vm.submitted && _vm.nameError,
                      clearable: true,
                      "max-length": 255,
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "document-form__type" },
                [
                  _c("c-input-2", {
                    style: {
                      "margin-bottom":
                        _vm.submitted && _vm.analyseTypeError ? "40px" : "",
                    },
                    attrs: {
                      "floating-label": "Тип анализа",
                      type: "select",
                      items: _vm.analysesTypes,
                      searchable: true,
                      required: _vm.submitted && _vm.analyseTypeError,
                      "required-condition":
                        _vm.submitted && _vm.analyseTypeError,
                      "required-mark": true,
                    },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "document-form__name" },
                [
                  _c("c-input-2", {
                    attrs: {
                      type: "select",
                      label: "Должности, для которых нужен анализ",
                      checkbox: true,
                      "checkbox-type": "icon",
                      "checkbox-value": _vm.form.postsAllExcept,
                      "checkbox-tooltip": {
                        disabledText:
                          "Фильтр по всем значениям в справочнике, кроме выбранных",
                        activeText:
                          "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                        notActiveText:
                          "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                      },
                      multiple: true,
                      searchable: true,
                      placeholder: "Все",
                      items: _vm.positions,
                    },
                    on: { checkboxChange: _vm.filterPosts },
                    model: {
                      value: _vm.form.posts,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "posts", $$v)
                      },
                      expression: "form.posts",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "document-form__name medical-form-expiring-days",
                },
                [
                  _c("c-input-2", {
                    style: {
                      "margin-bottom": _vm.expireDaysWrongValue ? "20px" : "",
                    },
                    attrs: {
                      "max-length": 10,
                      "input-text-condition":
                        _vm.expireDaysWrongValue && "Некорректное значение",
                      label: "Срок годности в днях",
                      placeholder: "0",
                    },
                    model: {
                      value: _vm.form.expireInDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "expireInDays", $$v)
                      },
                      expression: "form.expireInDays",
                    },
                  }),
                  _c("span", [_vm._v("дней")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "document-form__name medical-comment-input" },
                [
                  _c("c-input-2", {
                    attrs: {
                      "floating-label": "Комментарий",
                      clearable: true,
                      "max-length": 500,
                    },
                    model: {
                      value: _vm.form.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "comment", $$v)
                      },
                      expression: "form.comment",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "document-form__actions" },
              [
                _c("c-button-2", {
                  staticClass: "document-form__reset",
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.reset },
                }),
                _c("c-button-2", {
                  staticClass: "document-form__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }